'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Seasonality.CalendarGrids', dependencies).directive('rmSeasonalityCalendarGrids', require('./directives/SeasonalityCalendarGridsDirective'));